module.exports = __webpack_public_path__ + "static/media/md-baseball.15e7aaf4.svg";